/**
 * Regex to check only words, no other characters then a space
 * @type {RegExp}
 */

const onlyWords = /^[\w\s]+$/

export default onlyWords
